import React, { memo } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import { FireScreenAnalytics } from '@atlassian/jira-product-analytics-bridge';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import { FeaturesUpsellBanner } from '@atlassian/jira-service-management-cmdb-upsell-banner/src/ui/index.tsx';
import useReviseFeaturesResource from '../../controllers/common/revise-features-resource/index.tsx';
import { useFeatureVisibility } from '../../controllers/feature-visibility-provider/index.tsx';
import Header from './header';
import messages from './messages';
import LabsSection from './sections/labs-section/index.tsx';
import ServiceProjectSection from './sections/service-project-section/index.tsx';
import { CmdbUpsellWrapper } from './styled';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const App = memo<Record<any, any>>(() => {
	const { formatMessage } = useIntl();
	useReviseFeaturesResource();

	const { hasLabs } = useFeatureVisibility();

	const PageWrapper = getWillShowNav4() ? PageWrapperNew : PageWrapperOld;

	return (
		<>
			<PageWrapper>
				<Header title={formatMessage(messages.pageHeader)} />
				<div>{formatMessage(messages.pageDescription)}</div>
				<CmdbUpsellWrapper>
					<FeaturesUpsellBanner />
				</CmdbUpsellWrapper>
				<ServiceProjectSection />
				{(!fg('jcs_master_flag') || hasLabs) && <LabsSection />}
			</PageWrapper>

			{
				// eslint-disable-next-line jira/ff/no-preconditioning
				fg('jsm_boards_promo_gate') &&
				window.location.href?.includes('?queues-board-promotion=true') ? (
					<FireScreenAnalytics
						attributes={{
							isPracticeModularity: true,
							queuesBoardPromotion: true,
						}}
					/>
				) : (
					<FireScreenAnalytics attributes={{ isPracticeModularity: true }} />
				)
			}
			<SubmitApdex />
		</>
	);
});

export default App;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PageWrapperNew = styled.div({
	margin: '0 auto',
	padding: `0 ${token('space.300', '24px')}`,
	width: '800px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const PageWrapperOld = styled.div({
	margin: '0 auto',
	padding: `0 ${token('space.300', '24px')}`,
	width: '800px',
	overflow: 'auto',
});
